import { startCase } from 'lodash';
import { Subject } from 'rxjs';

import { KeyValue } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { SnAppliance } from '@lib/api/entities';
import { GoogleMap, GoogleMapMarker, GoogleMapMarkerType } from '@lib/geo/google/map';
import { SnLonLat } from '@lib/geo/helpers';

@Component({
  selector: 'sn-appliances-charger-control',
  templateUrl: './appliances-charger-control.component.html',
  styleUrls: ['./appliances-charger-control.component.scss'],
})
export class AppliancesChargerControlComponent implements OnInit, OnDestroy {
  @Input() public appliance: SnAppliance;

  public chargeControlData: any;
  public targetItems: any;
  public isLoading: boolean;
  private _map: GoogleMap;
  private readonly _destroy$ = new Subject<void>();

  constructor() {}

  public ngOnInit(): void {
    this.chargeControlData = this.appliance.reportMeta.chargeControllerMeta;
    const items = Object.entries(this.appliance.reportMeta);
    this.targetItems = items.filter(([key, value]: any) => {
      const values = ['modemMeta', 'chargeControllerMeta', 'switchMeta'];
      return values.includes(key);
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public setIcon(text: string): string {
    if (text === 'unknown') {
      return 'fa-cloud-question';
    }
    if (text === 'up') {
      return 'fa-cloud-check';
    }
    return 'fa-cloud-exclamation';
  }

  public getAppliaceLocation(data: any): SnLonLat {
    const lon = data.longitude;
    const lat = data.latitude;
    return new SnLonLat(lon, lat);
  }

  public onMapInit(googleMap: GoogleMap, data: any): void {
    this._map = googleMap;
    const lon = data.longitude;
    const lat = data.latitude;
    const lonLat = new SnLonLat(lon, lat);
    const pointMarker = new GoogleMapMarker({
      lonLat,
      type: GoogleMapMarkerType.PIN,
      clickable: false,
      draggable: false,
    });
    pointMarker.addTo(this._map);
  }

  public trackDetailItem(index: number, item?: KeyValue<string, any>): any {
    return item.key;
  }

  public originalOrder = (a: KeyValue<any, string>, b: KeyValue<any, string>): number => {
    return 0;
  };

  public isObject(item: any): boolean {
    return Object.prototype.toString.call(item).indexOf('Object') > -1;
  }

  public isArrays(item: any): boolean {
    return Array.isArray(item);
  }

  public exclude(key: string): boolean {
    return ['modemMeta'].indexOf(key) > -1;
  }

  public excludeData(key: string): boolean {
    return (
      [
        'connectivityStatus',
        'geoStatus',
        'lanClientStatus',
        'portForwardingStatus',
        'portStatus',
      ].indexOf(key) > -1
    );
  }

  public formatDataKeys(data: any[]): any[] {
    const formattedData: any = [];
    data.forEach((item: any) => {
      formattedData.push(
        Object.keys(item).reduce((accumulator, key) => {
          accumulator[key.toLowerCase()] = item[key];
          return accumulator;
        }, {}),
      );
    });
    return formattedData;
  }

  public toStartCase(text: string): string {
    return startCase(text);
  }
}
